export const residentFromResidenceType = ({ residenceType, clientType }) => {
  if (clientType === 'pro') {
    return 0
  }

  return residenceType === 'secondary' ? 0 : 1
}
